module.exports = __webpack_public_path__ + "img/Jaclyn.0a39ae7c.jpg";